import { SliderInput } from '@meitu/saas-ui';
import { IImageEffectShadow } from '@meitu/saas-editor-core/es/version-types';
import LabelAction from '@/components/label-action';
import { useLocaleStore } from '@/i18n';

const ReflectionShadowItem: React.FC<{
    shadow: IImageEffectShadow;
    updateData: (data: { key: string; value: any }[], pushHistory?: boolean, stopUpdate?: boolean) => void;
}> = ({ shadow, updateData }) => {
    const { $t } = useLocaleStore();
    const blurChange = (blur: number, isEnd = false) => {
        updateData([{ key: 'blur', value: blur }], isEnd, isEnd);
    };

    const distanceChange = (newDistance: number, isEnd = false) => {
        updateData([{ key: 'distance', value: newDistance }], isEnd, isEnd);
    };

    const brightnessChange = (newBrightness: number, isEnd = false) => {
        updateData([{ key: 'brightness', value: newBrightness }], isEnd, isEnd);
    };

    const opacityChange = (opacity: number, isEnd = false) => {
        updateData([{ key: 'opacity', value: opacity }], isEnd, isEnd);
    };

    const yOffsetChange = (newYOffset: number, isEnd = false) => {
        updateData([{ key: 'y', value: newYOffset }], isEnd, isEnd);
    };

    return (
        <>
            <LabelAction title={$t((v) => v.imageEffectPanel.imageShadowItem.blur)} align>
                <div
                    style={{
                        width: '100%',
                    }}
                >
                    <SliderInput
                        min={0}
                        max={100}
                        value={shadow?.blur ? shadow.blur * 100 : 0}
                        precision={1}
                        showStepBtn
                        type="horizontal"
                        onChange={(val: number) => {
                            blurChange(val / 100);
                        }}
                        onAfterChange={(val: number) => {
                            blurChange(val / 100, true);
                        }}
                        onClick={() => {}}
                    />
                </div>
            </LabelAction>

            <LabelAction title={$t((v) => v.imageEffectPanel.imageShadowItem.range)} align>
                <div
                    style={{
                        width: '100%',
                    }}
                >
                    <SliderInput
                        min={0}
                        max={100}
                        value={shadow?.distance || 0}
                        precision={1}
                        showStepBtn
                        type="horizontal"
                        onChange={(val: number) => {
                            distanceChange(val);
                        }}
                        onAfterChange={(val: number) => {
                            distanceChange(val, true);
                        }}
                        onClick={() => {}}
                    />
                </div>
            </LabelAction>

            <LabelAction title={$t((v) => v.imageEffectPanel.imageShadowItem.dis)} align>
                <div
                    style={{
                        width: '100%',
                    }}
                >
                    <SliderInput
                        min={-100}
                        max={100}
                        value={shadow?.y || 0}
                        precision={1}
                        showStepBtn
                        type="horizontal"
                        onChange={(val: number) => {
                            yOffsetChange(val);
                        }}
                        onAfterChange={(val: number) => {
                            yOffsetChange(val, true);
                        }}
                        onClick={() => {}}
                    />
                </div>
            </LabelAction>

            <LabelAction title={$t((v) => v.imageEffectPanel.imageShadowItem.brightness)} align>
                <div
                    style={{
                        width: '100%',
                    }}
                >
                    <SliderInput
                        min={-100}
                        max={100}
                        value={shadow?.brightness || 0}
                        precision={1}
                        showStepBtn
                        type="horizontal"
                        onChange={(val: number) => {
                            brightnessChange(val);
                        }}
                        onAfterChange={(val: number) => {
                            brightnessChange(val, true);
                        }}
                        onClick={() => {}}
                    />
                </div>
            </LabelAction>

            <LabelAction title={$t((v) => v.imageEffectPanel.imageShadowItem.opacity)} align>
                <div
                    style={{
                        width: '100%',
                    }}
                >
                    <SliderInput
                        min={0}
                        max={100}
                        value={(shadow?.opacity || 1) * 100}
                        precision={1}
                        showStepBtn
                        type="horizontal"
                        onChange={(val: number) => {
                            opacityChange(val / 100);
                        }}
                        onAfterChange={(val: number) => {
                            opacityChange(val / 100, true);
                        }}
                        onClick={() => {}}
                    />
                </div>
            </LabelAction>
        </>
    );
};

export default ReflectionShadowItem;
